import Link from 'components/shared/Link/Link';
import LinkedIcon from 'components/shared/LinkedIcon/LinkedIcon';
import { LinkedIconProps } from 'libs/contentful/types';
import { FooterColumnProps } from './types';
import { LinkTargets } from 'types/constants';

const FooterColumn = ({ heading, links }: FooterColumnProps) => {
  return (
    <div className="flex flex-col gap-2" data-testid="footerCol">
      <p className="font-bold mb-2 font-sans">{heading}</p>
      {links.map((link, index) => {
        if ('iconName' in link) {
          return (
            <LinkedIcon
              key={`${heading}-link-${index}`}
              iconName={(link as LinkedIconProps).iconName}
              url={link.url!}
              label={link.label}
            />
          );
        }

        return (
          <Link
            key={`${heading}-link-${link.label}`}
            data-testid="footerColumnLink"
            href={link.url}
            internalPage={link?.internalPage}
            target={link.target ?? LinkTargets.SameTab}
            className={`hover:text-fern focus:text-fern font-sans font-medium ${link.class || ''}`}
            id={link.id}>
            {link.label}
          </Link>
        );
      })}
    </div>
  );
};

export default FooterColumn;
